import { makeRequest } from "../helpers/makeRequest";
import { useAxiosPrivate } from "../hooks/useAxiosPrivate";

import { apiUrls } from "../helpers/apiUrls";
import { prepareUrlWithQueryParams } from "../helpers/methods";

export default function useFilterService() {
    const axiosPrivate = useAxiosPrivate();

    const getUserFilters = (searchParams) => {
        return makeRequest(
            axiosPrivate,
            prepareUrlWithQueryParams(apiUrls.filters.filters, searchParams),
        );
    };

    const createOrUpdateFilter = (formValue) => {
        const { id, ...dataToSend } = formValue;
        if (!id) {
            return createFilter(dataToSend);
        }
        return updateFilter(id, dataToSend);
    };

    const createFilter = (dataToSend) => {
        return axiosPrivate(apiUrls.filters.filters, {
            method: "POST",
            data: dataToSend,
        });
    };

    const updateFilter = (id, dataToSend) => {
        return axiosPrivate(apiUrls.filters.filter(id), {
            method: "PATCH",
            data: dataToSend,
        });
    };

    const deleteFilter = (id) => {
        return axiosPrivate(apiUrls.filters.filter(id), {
            method: "DELETE",
        });
    };

    return { getUserFilters, createOrUpdateFilter, deleteFilter };
}
